export default __webpack_public_path__ + "static/media/bl-screenflow.fb679fef.jpg";